var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11655(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4E4F54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7883 25.4822L33.5212 30.1039C30.6941 31.161 28.3833 34.5043 28.3833 37.5035V55.7689C28.3833 58.6697 30.3008 62.4801 32.6362 64.2255L43.2071 72.1168C46.6733 74.7226 52.3766 74.7226 55.8429 72.1168L66.4137 64.2255C68.7491 62.4801 70.6666 58.6697 70.6666 55.7689V37.5035C70.6666 34.4797 68.3558 31.1364 65.5287 30.0793L53.2616 25.4822C51.1721 24.7201 47.8287 24.7201 45.7883 25.4822Z",
    stroke: "white",
    strokeWidth: 4.602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2471 49.1805L46.205 53.1385L56.7758 42.5676",
    stroke: "white",
    strokeWidth: 4.602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11655);
export default __webpack_public_path__ + "static/media/Group 11655.5f157a25acf0fdc797e34b84ecd04f32.svg";
export { ForwardRef as ReactComponent };